export default __webpack_public_path__ + "static/media/AlmaSearch1.e56477b1.png";